module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_IT-9d714380dfb0d498d014a01e2b178221.svg";